/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseUserAccountEntity } from '../../models/api-response-user-account-entity';

export interface GetUserByUsername$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  username: string;
  companyId: string;
}

export function getUserByUsername(http: HttpClient, rootUrl: string, params: GetUserByUsername$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseUserAccountEntity>> {
  const rb = new RequestBuilder(rootUrl, getUserByUsername.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('username', params.username, {});
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseUserAccountEntity>;
    })
  );
}

getUserByUsername.PATH = '/v1/api/user-api/get/get-by-username/{companyId}/{username}';
